import React, {PropTypes} from 'react';

export default function redirectTo(to) {

    if (!to) throw Error ('redirectTo: "to" parameter is required');

    class Redirect extends React.Component {

        static contextTypes = {
            router: PropTypes.object.isRequired
        };

        componentWillMount() {
            this.context.router.push(to);
        }

        render() {
            return <div>Redirecting...</div>;
        }

    }

    return Redirect;

}
